export class Event {
  id: string;
  name: string;
  status: boolean;
}
